import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/core/assets/404.svg'


const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "lead font-size-2 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      alt: "not-found",
      width: "800",
      height: "600",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("error404.urlNotFound")), 1),
    _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
    _createVNode(_component_b_button, {
      variant: "primary",
      class: "my-2 my-sm-0",
      type: "button",
      onClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("error404.home")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}